import React from 'react';
import { Box } from '@mui/material';
import { Outlet } from 'react-router-dom';
import { CONTENT_MAX_WIDTH, mainSx } from './SectionLayout';

/** Pages without a section sidebar (dashboard, profile, Android app): the same margins and width. */
const PageLayout: React.FC = () => (
  <Box component="main" sx={mainSx}>
    <Box sx={{ maxWidth: CONTENT_MAX_WIDTH, mx: 'auto' }}>
      <Outlet />
    </Box>
  </Box>
);

export default PageLayout;
